module.exports = __webpack_public_path__ + "img/pimg9.abebc21a.png";